import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";
import { breakpoints } from "../../constants/breakpoints";

const styles = createUseStyles((theme) => ({
  companyDeletedContainer: {
    display: "flex",
    flexDirection: "column",
    margin: "10px auto",
    justifyContent: "space-between",
    width: "360px",
    height: "fit-content",
    padding: "16px 20px 16px 16px",
    boxSizing: "border-box",
  },
  title: {
    fontSize: "30px",
    lineHeight: "38px",
    textAlign: "center",
    marginTop: "24px"
  },
  description: {
    fontSize: "16px",
    lineHeight: "24px",
    textAlign: "center"
  },
  description2: {
    fontSize: "16px",
    lineHeight: "24px",
    textAlign: "center"
  },
  returnLink: {
    fontSize: "14px",
    lineHeight: "20px",
    display: "flex",
    flexDirection: "row",
    alignContent: "flex-end",
    textAlign: "center",
    justifyContent: "center"
  },
  returnText: {
    paddingRight: "4px",
    fontWeight: "400"
  },
  headerContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    padding: "32px 64px 32px 64px"
  },
  lang: {
    display: "flex",
    alignItems: "center",
    alignSelf: "end",
    margin: "32px 64px",
    height: "32px",
    "& :focus:not(.focus-visible)":{
      outline:0,
    },
    "& :focus-visible":{
      boxShadow: "0px 0px 0px 4px " + colors.lightBlue
    },
    "&:hover": {
      cursor: "pointer",
      textColor: theme.navigation.li.active.color,
    },
    "& .langSelector": {
      display: "flex",
      width: "100%",
      textDecoration: "none",
      color: colors.grey,
      borderRadius: "4px",
      "& div": {
        marginLeft: "14px",
        alignSelf: "center",
      },
    },
  },
  popoverImage:{
    marginRight:"8px",
    width:"20px",
    height:"20px",
    "& path": {
      stroke: colors.mediumGrey
    }
  },
  locale: {

  },
  overlayLink: {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    color: colors.mediumGrey,
    fontSize: "14px",
    fontWeight: "600",
    lineHeight: "20px",
    marginLeft:"24px",
    "&:hover": {
      color: colors.grey,
      backgroundColor: colors.brightBlue,
      borderRadius: "8px",
    },
    width: "100%",
  },
  overlayLinkSignOut: {
    extend: "overlayLink",
    "&:hover":{
      "& path": {
        stroke: colors.grey
      }
    }
  },
  flagStyle: {
    marginRight: "8px"
  },
}));

export default styles;